import { c as _c } from "react/compiler-runtime";
import { type ReactElement, type ReactNode } from 'react';
import { StyledTriggerMenuList, StyledTriggerMenuPopper } from './styles';
export interface ComposerTriggerMenuProps {
  open: boolean;
  anchorEl: {
    getBoundingClientRect: () => DOMRect;
  } | null;
  width: string;
  maxHeight: string;
  children: ReactNode;
}

/**
 * Shared caret-anchored popper + list for composer triggers (`@` mentions, `/` commands).
 */
export const ComposerTriggerMenu = t0 => {
  const $ = _c(8);
  const {
    open,
    anchorEl,
    width,
    maxHeight,
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <StyledTriggerMenuList>{children}</StyledTriggerMenuList>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== anchorEl || $[3] !== maxHeight || $[4] !== open || $[5] !== t1 || $[6] !== width) {
    t2 = <StyledTriggerMenuPopper open={open} anchorEl={anchorEl} placement="top-start" menuWidth={width} menuMaxHeight={maxHeight}>{t1}</StyledTriggerMenuPopper>;
    $[2] = anchorEl;
    $[3] = maxHeight;
    $[4] = open;
    $[5] = t1;
    $[6] = width;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};